/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */

import React, { useMemo } from "react";
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { initializeLogging } from "@nuance/hux-diagnostics/";
import { ErrorDialog } from "./Dialogs/ErrorDialog";
import { MainFrame } from "./Mainframe/Mainframe";
import "./App.css";
import { LIB_VERSION } from "./version";
import { appInsightsConnectionString } from "./ApplicationInsights";

const App = (): JSX.Element => {
    const reactPlugin = useMemo(
        () => initializeLogging(appInsightsConnectionString, "HS-Designer", LIB_VERSION),
        []
    );
    return (
        <AppInsightsErrorBoundary appInsights={reactPlugin as never} onError={ErrorDialog}>
            <React.Suspense fallback="Loading...">
                <MainFrame />
            </React.Suspense>
        </AppInsightsErrorBoundary>
    );
};

export default App;
